$shm_hitalama_map_widget_float_echarts $shm_hitalama_map_widget_float
	controls /
		<= Echarts $shm_echarts
			option <= option null
	width_min 240
	height_min 200
	contextmenu_body /
		<= Settings_add $mol_button_minor
			title \Добавить виджет настроек
			click? <=> settings_add? null
		<= Filters_add $mol_pop_over
			align \right_bottom
			Anchor <= Filters_add_anchor $mol_button_minor
				title \Добавить фильтр
			bubble_content /
				<= Filters $mol_list
					sub <= filter_buttons /
						<= Filter_add*0 $mol_button_minor
							title <= filter_name* \
							click? <=> filter_add*? null
		^
